export { VpTextLimit } from './VpTextLimit';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTextLimit/index.js